import { Box, Center } from '@mantine/core';
import type { SyncState } from 'shared/hooks/use-load-syncs';

import classes from './SyncDot.module.css';

const STATE_COLORS: Record<SyncState, string> = {
  never_synced: 'gray.5',
  running: 'purple.4',
  healthy: 'green.4',
  failing: 'error.5',
};

const STATE_HALOS: Record<SyncState, string> = {
  never_synced: 'gray.3',
  running: 'purple.2',
  healthy: 'green.1',
  failing: 'error.2',
};

type SyncDotProps = {
  state: SyncState;
};

export const SyncDot = ({ state }: SyncDotProps) => (
  <Center
    bg={STATE_HALOS[state]}
    w={18}
    h={18}
    className={state === 'running' ? classes.pulsingHalo : undefined}
    style={{ borderRadius: '50%' }}
  >
    <Box bg={STATE_COLORS[state]} w={8} h={8} style={{ borderRadius: '50%' }} />
  </Center>
);
